/*
 *  Copyright 2025 LiteFarm.org
 *  This file is part of LiteFarm.
 *
 *  LiteFarm is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  LiteFarm is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 *  GNU General Public License for more details, see <https://www.gnu.org/licenses/>.
 */

import { createContext, Dispatch, SetStateAction, useContext } from 'react';

export type NavMenuControls = {
  feedback: {
    isFeedbackSurveyOpen: boolean;
    setFeedbackSurveyOpen: Dispatch<SetStateAction<boolean>>;
  };
};

export const NavMenuControlsContext = createContext<NavMenuControls | null>(null);

export const useNavMenuControls = () => {
  const NavMenuControls = useContext(NavMenuControlsContext);
  if (!NavMenuControls) {
    throw new Error('NavMenuControlsContext must be used within a provider');
  } else {
    return NavMenuControls;
  }
};
